export default __webpack_public_path__ + "static/media/side1.1ab4a9fe.svg";